import { Image, Link } from '@shopify/hydrogen'
import { useContext } from 'react'
import { HeaderContext } from '../header/header-provider.client'
import styles from '../../assets/scss/components/mobile-menu.module.scss'
import { useI18n } from '../i18n.client'
import { LanguageSwitch } from '../language/language-switch.client'
import { EnhancedMenu, EnhancedMenuItem } from '../../lib/menus'

export const ParentMenu: React.FC<{ menu: EnhancedMenu }> = ({ menu }) => {
  const { activeMobileParentMenuIndex, setIsMainNavigationOpen } = useContext(HeaderContext)
  const [i18n] = useI18n()

  if (activeMobileParentMenuIndex !== undefined) {
    return null
  }

  return (
    <div className={styles.parentMenu}>
      <div className={styles.close} onClick={() => setIsMainNavigationOpen(false)}>
        {i18n.translate('close')}
      </div>
      <div>
        {menu.items.map((item, index) => (
          <MenuItem index={index} item={item} key={item.id} />
        ))}
      </div>
      <div className={styles.footer}>
        <Image
          alt="Marie Lichtenberg"
          className={styles.stamp}
          height={51}
          src="/marie-lichtenberg-stamp.png"
          width={217}
        />
        <LanguageSwitch isWhite />
      </div>
    </div>
  )
}

const MenuItem: React.FC<{ index: number; item: EnhancedMenuItem }> = ({ index, item: { items, title, to } }) => {
  const [i18n] = useI18n()
  const { setActiveMobileParentMenuIndex, setIsMainNavigationOpen } = useContext(HeaderContext)

  if (items.length) {
    return (
      <div className={styles.menuItem} onClick={() => setActiveMobileParentMenuIndex(index)}>
        {title} +
      </div>
    )
  }

  if (to) {
    return (
      <Link className={styles.menuItem} onClick={() => setIsMainNavigationOpen(false)} to={to}>
        {title}
      </Link>
    )
  }

  return null
}
